import { CanActivateFn } from '@angular/router';
import { CognitoJwtVerifier } from 'aws-jwt-verify';
import { Observable, of } from 'rxjs';
import { inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AUTH_CONFIG, AuthConfig } from '@domgen/dgx-fe-authentication';

interface ExtendedAuthConfig extends AuthConfig {
  cognitoPool: {
    userPoolId: string;
    clientId: string;
    region: string;
  };
  myAccountLogoutPage: string;
  myAccountBaseDomain: string;
  domain: string;
}

export const authGuard: CanActivateFn = (): Observable<boolean> => {
  const cookieService = inject(CookieService);
  const authConfig = inject(AUTH_CONFIG) as ExtendedAuthConfig;
  const token: any = cookieService.get('AWS_IDT');

  const isCypress = !!(window as any).Cypress;

  if (isCypress) {
    // Bypass auth for Cypress tests
    return of(true);
  }

  if (!token) {
    window.location.href = `${authConfig.myAccountBaseDomain}/my-plans?redirectTo=${authConfig.domain}`;
    return of(false);
  }
  if (!authConfig.cognitoPool) {
    window.location.href = `${authConfig.myAccountBaseDomain}?/my-plans?redirectTo=${authConfig.domain}`;
    return of(false);
  }

  const verifier = CognitoJwtVerifier.create({
    userPoolId: authConfig.cognitoPool.userPoolId,
    tokenUse: 'id',
    clientId: authConfig.cognitoPool.clientId,
  });

  return new Observable<boolean>((observer) => {
    console.debug('[authGuard] Verifying token...');
    verifier
      .verify(token)
      .then((payload) => {
        const customerId = payload['sub'];
        if (customerId) {
          localStorage.setItem('customerId', customerId);
        }
        observer.next(true);
        observer.complete();
      })
      .catch((error) => {
        console.error('[authGuard] Token verification failed:', error);
        observer.next(false);
        window.location.href = `${authConfig.myAccountBaseDomain}?/my-plans?redirectTo=${authConfig.domain}`;
        observer.complete();
      });
  });
};
